<template>
  <component
    class="text-navy text-22 font-sans font-bold"
    :is="headingTag.toLowerCase()">
    <slot></slot>
  </component>
</template>

<script>
import { useIsHeaderTag } from "../../../compostables/useValidators";

export default {
  props: {
    headingTag: {
      type: String,
      required: false,
      default: "h3",
      validator(value) {
        return useIsHeaderTag(value);
      },
    },
  },
};
</script>

<style lang="scss" scoped></style>
